import Seo from "@/components/Seo";
import Gallery from "@/components/home/Gallery";
import LeadSection from "@/components/home/LeadSection";

export default function GaleriPage() {
  return (
    <>
      <Seo title="Galeri | Ankara Gelin Damat Çekimi Fotoğrafları"
        description="Ankara ve ilçelerinde çektiğimiz gelin damat dış çekim ve düğün fotoğraflarından seçmeler. Doğal, zamansız ve sinematik kareler."
        path="/galeri" />
      <div className="pt-16">
        <Gallery />
      </div>
      <LeadSection />
    </>
  );
}
